import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { UserState } from '../_shared/state/user.state';
import { AppState } from '../app.state';
import { FollowedPropertiesState } from '../followed-properties/state/followed-properties.state';

@Component({
  selector: 'app-saved-component',
  templateUrl: './saved-component.component.html',
  styleUrls: ['./saved-component.component.scss']
})
export class SavedComponentComponent implements OnInit {
  selectedTabIndex: number;
  onDestroyNotifier$ = new Subject();
  createWatchListSheetActive: boolean = false;
  userRoleList = ['agent', 'loanOfficer', 'companyManager'];
  userRole: any;

  constructor(public appState: AppState, private route: ActivatedRoute, private router: Router, public followedPropertiesState: FollowedPropertiesState, public userState: UserState,) { }

  ngOnInit(): void {
    this.userState.isPropertySearchSheetOpen = false;
    this.route.queryParamMap
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(params => {
        const tab = params.get('tab');
        this.selectTab(tab)
      });
    this.followedPropertiesState.openCreateWatchListSheet$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((status) => {
        this.createWatchListSheetActive = status;
      });
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data) => {
      if (data) {
        this.userRole = data?.userType;
      }
    });

  }
  selectTab(tabLabel) {

    if (tabLabel == 'rentalAnalysis') {
      this.selectedTabIndex = 2
    } else if (tabLabel == 'watchList') {
      this.selectedTabIndex = 1
    } else if (tabLabel == 'savedSearch') {
      this.selectedTabIndex = 0
    } else if (tabLabel == 'equityAnalysis') {
      this.selectedTabIndex = 2
    }
    else {
      this.selectedTabIndex = 0
    }

    return this.selectedTabIndex;
  }

  updateUrl(tabName: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: tabName }
    });


  }
  onTabChange(event: MatTabChangeEvent) {
    if (event.tab.ariaLabel === 'WatchList') {
      this.updateUrl('watchList');
    }
    if (event.tab.ariaLabel === 'Rental Analysis') {
      this.updateUrl('rentalAnalysis');
    }
    if (event.tab.ariaLabel === 'Saved Search') {
      this.updateUrl('savedSearch');
    }
    if (event.tab.ariaLabel === 'Equity Analysis') {
      this.updateUrl('equityAnalysis');
    }
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
